import tooltips from "./tooltips";
import BioModal from "./bioModal";
import trackContentDownloads from "./trackContentDownloads";
import CommonGlobalEvents from "./commonGlobalEvents";
import ViewportDirectiveSettings from "./viewportDirectiveSettings";
import AllInvestmentsMixin from "./allInvestments";
import validationRulesEmail from "./validationRulesEmail";
import validationRulesPassword from "./validationRulesPassword";
import backgroundPositionClass from "./backgroundPositionClass";

export default {
	tooltips,
	BioModal,
	trackContentDownloads,
	CommonGlobalEvents,
	ViewportDirectiveSettings,
	AllInvestmentsMixin,
	validationRulesEmail,
	validationRulesPassword,
	backgroundPositionClass
};
